module.exports = __webpack_public_path__ + "static/media/traffic_light_state_diagram.3c9a109b.jpg";